/**
 * System Connections API Module
 * Handles all system connection related API operations
 */

import { AxiosResponse } from 'axios'
import { apiClient } from '../core/apiClient'

export interface SystemConnection {
  id: number
  system_name: string
  connection_id: string
  secret_name: string
  metadata: {
    tenant_name?: string
    tenant_id?: string
    store_code?: string
    api_account_id?: string
    last_connected?: string
    api_url?: string
    environment?: string
  }
  is_active: boolean
  created_at: string
  updated_at: string
}

export const systemConnectionsApi = {
  getConnections: (fpCode: string): Promise<AxiosResponse<SystemConnection[]>> =>
    apiClient.get(`/systems/connections/${fpCode}`),
    
  addConnection: (fpCode: string, connectionData: any): Promise<AxiosResponse<SystemConnection>> =>
    apiClient.post(`/systems/connections/${fpCode}`, connectionData),
    
  updateConnection: (fpCode: string, connectionId: string, connectionData: any): Promise<AxiosResponse<SystemConnection>> =>
    apiClient.put(`/systems/connections/${fpCode}/${connectionId}`, connectionData),
    
  deleteConnection: (fpCode: string, connectionId: string): Promise<AxiosResponse<{ message: string }>> =>
    apiClient.delete(`/systems/connections/${fpCode}/${connectionId}`),
}